import React, { useEffect, useState } from "react";

const SHEET_URL =
  "https://opensheet.elk.sh/1zJYzeNrKT_oJCYoDpNzFyXNFnShthQISmrgNakNoFtU/Arkusz1";
const MAX_SPOTS = 12;

export default function SlotCounter() {
  const [confirmedCount, setConfirmedCount] = useState(null);

  useEffect(() => {
    fetch(SHEET_URL)
      .then((res) => res.json())
      .then((data) => {
        const confirmed = data.filter(
          (row) =>
            row["Potwierdzony"]?.toString().toLowerCase().trim() === "tak"
        );
        setConfirmedCount(confirmed.length);
      })
      .catch(() => setConfirmedCount(null));
  }, []);

  if (confirmedCount === null) {
    return (
      <p className="text-gray-500 text-center mt-4 animate-pulse">
        
      </p>
    );
  }

  const remaining = Math.max(0, MAX_SPOTS - confirmedCount);
  const isLastSpots = remaining <= 3;

  return (
    <div
      className={`text-center mt-6 p-4 rounded-lg shadow-md border transition-all duration-300 ${
        isLastSpots
          ? "bg-red-100 text-red-700 border-red-300"
          : "bg-green-100 text-green-800 border-green-300"
      }`}
    >
      <p className="text-lg font-medium">Dostępne miejsca:</p>
      <p className="text-4xl font-bold mt-2 tracking-wide">{remaining}</p>
      {isLastSpots && (
        <p className="text-sm mt-1 font-semibold uppercase animate-pulse">
          Zostało niewiele miejsc!
        </p>
      )}
    </div>
  );
}
